export const title = 'CTR médio';

CTR (Click Through Rate) é a taxa de abertura das notificações, calculada como `qtd_aberturas / qtd_notificacoes_recebidas`.

Esta métrica representa a média do CTR entre todas as campanhas.

`qtd_aberturas` é a quantidade de notificações recebidas e abertas pelos clientes.

`qtd_notificacoes_recebidas` é a quantidade de notificações recebidas pelos clientes.
